import   React               ,
       { useState            ,
         useEffect           ,
         ChangeEvent         }  from "react";

import   classNames             from "classnames";

import   styles                 from "./Field.module.scss";

import   Icon                   from "../images/Icon";


import   LegalStructureSelector       from '../../block/legalStructureManagment/LegalStructureSelector';

import { LegalStructure                ,
         initializedLegalStructure     }  from '../../../dataTypes/legalStructureManagment/types';

export interface FieldLegalStructureProps {
  placeholder?   : string;
  value?         : string;
  autocomplete?  : string;
  readOnly?      : boolean;
  onChange?      : (event: React.ChangeEvent<HTMLInputElement>, value?: string | Date) => void;
  width?         : string;
  height?        : string;
  glowColor?     : string;
  dateFormat?    : string;
  legalStructures : LegalStructure[];
}

export const FieldLegalStructure = ({ placeholder                  ,
                        value        = ""            ,
                        autocomplete                 ,
                        readOnly                     ,
                        onChange                     ,
                        width        = "100%"        ,
                        height       = "fit-content" ,
                        glowColor    = "var(--color-Field-Focus-normal)"      ,
						legalStructures              }: FieldLegalStructureProps) => {

  const fieldStyle = { "--glow-color": glowColor } as React.CSSProperties;

  const [ inputValue   , setInputValue   ] = useState(value);
  const [ hasFocus     , setHasFocus     ] = useState(false);
  const [ showLegalStructureSelector , setShowLegalStructureSelector ] = useState(false);
  const [       , setChoosenLegalStructure      ] = useState<LegalStructure>(initializedLegalStructure());
//  const [ legalStructures    , setLegalStructures    ] = useState<LegalStructure[]>([])


  useEffect(() => {

    if (!hasFocus)
     {
      setInputValue(value);
    }
  }, [value, hasFocus]);

  
  
  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {

    const input = event.target.value;

    setInputValue(input);
 
    if (onChange)
     {
      onChange (event, input as string);
     }
  };



  const handleLegalStructureSelectorHide = () => {
    setShowLegalStructureSelector(false);
  }

 const handleLegalStructureSelection = (id: number) => {
	  
    setShowLegalStructureSelector(false);
	
    for (let v = 0; v < legalStructures.length; v++) {
      if (legalStructures[v].id === id) {

        setChoosenLegalStructure (legalStructures[v]);
		
		const input = `${legalStructures[v].id} - ${legalStructures[v].tradeName} - ${legalStructures[v].companyName}`

        setInputValue(input);

/*
        if (onChange)
         {
          onChange (event, input as string);
         }	
/*
        const updatedFields = { ...fields, mediaId: medias[v].id, resultImageFile: lastImageFile };
        setFields(updatedFields);

        if (onChange) {
          const updatedSalesAction: SalesAction = { ...initialSalesAction, ...updatedFields };
          onChange(updatedSalesAction);
        }
*/
        break;
      }
    }
	
   // setLegalStructureIdMessage ( testLegalStructure ( choice.id ) )
  };
  
  const renderInput = (): JSX.Element => {

    const textInputProps = {
      className    : classNames(styles.field_input),
      placeholder ,
      value        : inputValue ,
      onChange     : (e: ChangeEvent<HTMLInputElement>) => handleChange(e),
      onFocus      : () => setHasFocus(true),
      onBlur       : () => setHasFocus(false),
    };

    return (
            <div className = { classNames ( styles.field_with_icon  ) } >
              <input {...textInputProps} type="text" />
                <Icon onClick    = {() => setShowLegalStructureSelector(!showLegalStructureSelector)}
                      name       = "addressBook"
                      color      = "var(--color-Field-Icon-normal)"
                      hoverColor = "var(--color-Field-Icon-hover-normal)" />
            </div>
          );
  };

  return (
    <div className={classNames(styles.field)} style={{ width, height, ...fieldStyle }}>
	  {
              showLegalStructureSelector &&
              <LegalStructureSelector legalStructureSet = {legalStructures}
                                      onCancel          = {handleLegalStructureSelectorHide}
                                      onSelect          = {handleLegalStructureSelection} />
      }
	
      {renderInput()}
    </div>
  );
};

export default FieldLegalStructure;
